import React, {useEffect, useState} from 'react';
import Row from 'react-bootstrap/Row';
import {
  faArrowsAltH,
  faArrowUp,
  faArrowDown,
  faClock,
} from '@fortawesome/free-solid-svg-icons';
import {DashboardCard, DashboardRow} from './utils';
import promiseRetry from 'promise-retry';
import {NavLink} from 'react-router-dom';
import Col from 'react-bootstrap/Col';
import {DASHBOARD_ROUTES} from '../navigation/dashboard/DashboardRoutes';
import {buildRoute} from '../navigation/navigationUtils';

export const Statistics = ({client, lean}) => {
  const [max, setMax] = useState('- -');
  const [min, setMin] = useState('- -');
  const [avg, setAvg] = useState('- -');
  const [count, setCount] = useState('- -');

  useEffect(() => {
    promiseRetry((retry) => {
      return client
        .getStatistics()
        .then((statistics) => {
          setMax(statistics.max);
          setMin(statistics.min);
          setAvg(statistics.avg);
          setCount(statistics.count);
        })
        .catch(retry);
    });
  }, [client]);
  let maxCard = (
    <DashboardCard
      icon={faArrowUp}
      value={max}
      key={1}
      description="Maximum heart rate"
      backgroundColor="#222"
    />
  );

  let minCard = (
    <DashboardCard
      icon={faArrowDown}
      value={min}
      key={2}
      description="Minimum heart rate"
      backgroundColor="#222"
    />
  );

  let avgCard = (
    <DashboardCard
      icon={faArrowsAltH}
      value={avg}
      key={3}
      description="Average heart rate"
      backgroundColor="#222"
    />
  );

  let hoursCard = (
    <DashboardCard
      icon={faClock}
      key={4}
      value={count === '- -' ? '- -' : (parseFloat(count) / 3600).toFixed(0)}
      description="Hours broadcasted"
      backgroundColor="#222"
    />
  );

  if (lean) {
    return [maxCard, minCard, avgCard, hoursCard];
  } else {
    return (
      <DashboardRow header="Overall statistics">
        <NavLink
          style={{textDecoration: 'none'}}
          to={buildRoute({path: DASHBOARD_ROUTES.REPORTS})}
        >
          <Row>
            <Col className="p-2">{maxCard}</Col>
            <Col className="p-2">{minCard}</Col>
          </Row>
          <Row>
            <Col className="p-2">{avgCard}</Col>
            <Col className="p-2">{hoursCard}</Col>
          </Row>
        </NavLink>
      </DashboardRow>
    );
  }
};
